export default __webpack_public_path__ + "fonts/color_techno.10a04c69e9df03c47fe9feb37eff3a28.png";